// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__bBuds","header":"PatientBlock_header__1sMzJ","label":"PatientBlock_label__3y1_0","option":"PatientBlock_option__1ikYW"};